import React from 'react';

export const initialGlobalContext = {
    isMobile: false,
    Howler: {
        loading: false,
        playing: false,
        mute: false
    },
    isPlaying: false,
    isLoading: false,
    isPaused: false,
    isMute: false,
    volumeIndex: 4,
    radioError: false,
    setRadioError: (data: boolean) => {},
    ragStatus: 'yellow',
    ragMessage: '',
    retryCountdown: 0,
    connectionLost: false,
    handlePlay: () => {},
    handleStop: () => {},
    handleMute: () => {},
    handleVolume: () => {},
};

export const GlobalContext = React.createContext(initialGlobalContext);
